import React, { useEffect, useState } from 'react'
import {useTable, useSortBy, usePagination, useGlobalFilter} from "react-table";
// import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import NewPagination from 'components/Common/Newpagination';
import {Table, Row, Col, CardBody,Card, Container, Form} from "reactstrap"
import { useMemo } from 'react';

function TableContainer({columns, data}) {
    const[fixedContent, setFixedContent] = useState("")

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        setPageSize,
        pageOptions,
        setGlobalFilter,
        pageCount,
        prepareRow,
      } = useTable(
        {
          columns,
          data,
          initialState: {
            sortBy: [
              {
                id: "id", // Set the ID of the first column for default sorting
                desc: true, // `true` for descending, `false` for ascending
              },
            ],
          },
        },
    
        useGlobalFilter,
        useSortBy,
        usePagination
      )
  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  return (
    <div>

        <Row className="mb-2">
         
            <Col>
            <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e =>  setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
            </Col>
            <Col md={8} className="d-flex justify-content-end">
            <div className="">
                <div className="search-box me-xxl-0 my-xxl-0 d-inline-block">
                <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                    <span id="search-bar-0-label" className="sr-only">
                        Search this table
                    </span>
                    <input
                        onChange={e => setGlobalFilter(e.target.value)}
                        id="search-bar-0"
                        type="text"
                        className="border-radius form-control rounded h-100"
                        placeholder={` Search...`}
                        value={globalFilter || ""}
                    />
                    </label>
                    <i className="bx bx-search-alt search-icon"></i>
                </div>
                </div>
            </div>
            </Col>
        </Row>
        <div className="position-relative">   
            <Table className="table table-bordered" {...getTableProps()}>
            <thead
                className={`${
                fixedContent ? "fixed-punch-details-header" : "fix-table-header"
                } `}
            >
                {headerGroups.map((headerGroup, i) => (
                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => {
                    const classNames = column.className
                    return (
                        <th
                        key={index}
                        className={`col-t-${index + 1} ${classNames} customShortIcon`}
                        // {...column.getHeaderProps()}
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        >
                        <div
                            // className={`position-relative d-flex ${
                            // column.isShortIcon
                            //     ? "justify-content-center"
                            //     : "justify-content-center"
                            // }`}
                        >
                            {/* {index === 0 && <span></span>} */}
                            {/* <span
                      
                            style={{
                                position: index === 0 ? "absolute" : "",
                                left: index === 0 ? "45%" : "",
                            }}
                            >
                            </span> */}
                            {column.render("Header")}
                            {column.isShortIcon ? (
                            <span
                                // style={{
                                // position: index != 0 ? "absolute" : "",
                                // right: index != 0 ? "0" : "",
                                // }}
                                onClick={() =>
                                column.getSortByToggleProps().onClick()
                                }
                            >
                                <i
                                title="Ascending"
                                className={`bi bi-arrow-up ms-1 info-icon ${
                                    column.isSorted && !column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                                ></i>
                                <i
                                title="Descending"
                                className={`bi bi-arrow-down info-icon ${
                                    column.isSorted && column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                                ></i>
                            </span>
                            ) : null}
                        </div>
                        </th>
                    )
                    })}
                </tr>
                ))}
            </thead>

            <tbody className="fix-punch-table-body" {...getTableBodyProps()}>
                {page.map((row, i) => {
                prepareRow(row)
                const { status: status_col, work_time: work_time_col } = row.original
                // const status = row.original.status_name

                let backgroundColor = ""
               
                if(status_col == "L"){
                    backgroundColor = "#ff9c9c"
                }
                if(status_col == "P" && work_time_col == "00:00"){
                    backgroundColor = "#f8c15e"
                }
                if(status_col == "WO" || status_col == "H"){
                    backgroundColor = "#add8e6"
                }

                
                let style = {backgroundColor}

                const priority = row.original.priority_col

                return (
                    // <tr {...row.getRowProps()} key={i} style={{backgroundColor: status_col === "L" ? backgroundColor : "red" ? (status_col === "P" && work_time_col == "00" ? backgroundColor : "yellow" ): "" }}>
                    <tr {...row.getRowProps()} key={i} style={style}>
                    {row.cells.map((cell, index) => (
                        <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className} ${
                            priority == "High" ? "highPriority" : ""
                        }`}
                       
                        {...cell.getCellProps()}
                        >
                        {cell.render("Cell")}
                        </td>
                    ))}
                    </tr>
                )
                })}
            </tbody>
            </Table>
        </div>

        {/* Pagination */}
        <Row className="justify-content-md-end justify-content-center align-items-center">
            <NewPagination
            gotoPage={gotoPage}
            canPreviousPag={canPreviousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            page={page}
            data={data}
            />
        </Row>
    </div>
  )
}

const PunchPreview = () => {
    const columns = useMemo(
        () => [
          {
            Header: "Date",
            accessor: "date",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center pp_date",
          },
          {
            Header: "Punch In",
            accessor: "punch_in",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center punch_in",
          },
          {
            Header: "Punch Out",
            accessor: "punch_out",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center punch_out",
          },
          {
            Header: "Work Time",
            accessor: "work_time",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center work_time",
          },
          {
            Header: "Punctual Deduction",
            accessor: "punctual_deduction",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center punctual_deduction",
          },
          {
            Header: "Status",
            accessor: "status",
            isInfoIcon: false,
            isShortIcon: true,
            className: "text-center status",
          },
        ],
        []
      )
    
      const data = [
        {
          date: "30/09/2024",
          punch_in: "09:29:14",
          punch_out: "19:52:23",
          work_time: "10:23",
          punctual_deduction: "0",
          status: "P",
        },
        {
          date: "29/09/2024",
          punch_in: "-",
          punch_out: "-",
          work_time: "",
          punctual_deduction: "",
          status: "WO",
        },
        {
            date: "28/09/2024",
            punch_in: "09:29:14",
            punch_out: "19:52:23",
            work_time: "00:00",
            punctual_deduction: "0",
            status: "P",
        },
        {
            date: "27/09/2024",
            punch_in: "09:29:14",
            punch_out: "19:52:23",
            work_time: "10:30",
            punctual_deduction: "0",
            status: "P",
        },
        {
          date: "26/09/2024",
          punch_in: "-",
          punch_out: "-",
          work_time: "-",
          punctual_deduction: "-",
          status: "H",
        },
        {
            date: "25/09/2024",
            punch_in: "09:29:14",
            punch_out: "19:52:23",
            work_time: "09:56",
            punctual_deduction: "0",
            status: "P",
        },
        {
            date: "24/09/2024",
            punch_in: "09:29:14",
            punch_out: "19:52:23",
            work_time: "10:00",
            punctual_deduction: "0",
            status: "P",
        },
          {
            date: "23/09/2024",
            punch_in: "09:29:14",
            punch_out: "19:52:23",
            work_time: "00:00",
            punctual_deduction: "0",
            status: "P",
          },
          {
            date: "22/09/2024",
            punch_in: "-",
            punch_out: "-",
            work_time: "-",
            punctual_deduction: "-",
            status: "WO",
          },
          {
            date: "21/09/2024",
            punch_in: "-",
            punch_out: "-",
            work_time: "-",
            punctual_deduction: "-",
            status: "WO",
          },
          {
            date: "20/09/2024",
            punch_in: "-",
            punch_out: "-",
            work_time: "-",
            punctual_deduction: "-",
            status: "L",
          },
          {
            date: "19/09/2024",
            punch_in: "-",
            punch_out: "-",
            work_time: "-",
            punctual_deduction: "-",
            status: "H",
          },
      ]
  // const data = [
  //   {
  //     id: "1",
  //     assign_name: "Robin",
  //     location: "India",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Work",
  //     duedate: "03/10/2024",
  //     priority_col: "Medium",
  //     spent_hours: "3.30 hrs",
  //   },
  //   {
  //     id: "2",
  //     assign_name: "Devil",
  //     location: "UK",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Finance",
  //     duedate: "05/10/2024",
  //     priority_col: "High",
  //     spent_hours: "30 min",
  //   },
  //   {
  //     id: "3",
  //     assign_name: "Rita",
  //     location: "UK",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Human Resource",
  //     duedate: "05/10/2024",
  //     priority_col: "High",
  //     spent_hours: "1.45 hrs",
  //   },
  //   {
  //     id: "4",
  //     assign_name: "Sumit",
  //     location: "India",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Sales",
  //     duedate: "05/10/2024",
  //     priority_col: "High",
  //     spent_hours: "2.45 hrs",
  //   },
  //   {
  //     id: "5",
  //     assign_name: "Ronnie",
  //     location: "India",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Sales",
  //     duedate: "05/10/2024",
  //     priority_col: "High",
  //     spent_hours: "15 min",
  //   },
  //   {
  //     id: "6",
  //     assign_name: "Sapna",
  //     location: "India",
  //     task_name: "Changes in Design of Roles & Permission, Support, General Task, Payroll Management, adding changes flow of this section in knowledge base.",
  //     relatedto: "Sales",
  //     duedate: "03/10/2024",
  //     priority_col: "High",
  //     spent_hours: "1.00 hrs",
  //   },
   
  // ]
  return (
    <>
     <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Payroll Management"}
            breadcrumbItem={"View Punch Details - Rahul Ovhal"}
          />

        
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                <Col className=' text-dark py-1 mb-4' style={{backgroundColor :"#dde2fa"}}>
                   <div className='d-flex gap-2 ps-2 justify-content-start align-items-center'>
                        <i className="bi bi-1-circle-fill text-primary" style={{fontSize :"30px"}}></i>
                        {/* <h5 className='p-0 m-0'>Punch Preview</h5> */}
                        Punch Preview
                   </div>
                </Col>
                  <TableContainer columns={columns} data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>

  )
}

export default PunchPreview